<template>
  <v-app :style="{ background: $vuetify.theme.themes[isDark].background }">
    <navbar />
    <v-main>
      <snack />
      <refresh-modal />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import Snack from "@/components/Snack";
import RefreshModal from "@/components/RefreshModal.vue";

export default {
  name: "App",

  components: {
    Navbar,
    Snack,
    RefreshModal,
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  created() {
    const locale = localStorage.getItem("locale");

    if (locale) {
      this.$i18n.locale = locale;
    } else if (navigator.language) {
      this.$i18n.locale = navigator.language.substring(0, 2);
    }
  },
};
</script>

<style lang="scss"></style>
